// blakfy-cookie/src/i18n/translations/fr.js — French translations

export default {
  title: "Préférences des Cookies",
  intro:
    "Ce site utilise des cookies pour améliorer votre expérience. Consultez notre Politique de Cookies pour plus de détails.",
  policyLink: "Politique de Cookies",
  acceptAll: "Tout Accepter",
  rejectAll: "Tout Refuser",
  preferences: "Préférences",
  save: "Enregistrer",
  close: "Fermer",
  cat: {
    essential: {
      title: "Cookies Essentiels",
      desc: "Nécessaires au fonctionnement du site. Ne peuvent pas être désactivés.",
      always: "Toujours actif",
    },
    analytics: {
      title: "Cookies Analytiques",
      desc: "Utilisés pour collecter des statistiques de visite anonymes.",
    },
    marketing: {
      title: "Cookies Marketing",
      desc: "Utilisés pour la publicité personnalisée et le reciblage.",
    },
    functional: { title: "Cookies Fonctionnels", desc: "Utilisés pour mémoriser vos préférences." },
  },
  placeholder: {
    title: "Contenu bloqué",
    desc: "Vous devez autoriser les cookies {category} pour voir ce contenu.",
    cta: "Autoriser",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
